<template>
    <app-step>
      <nights-two-columns>
        <template v-slot:left>
            <discount-code-checker></discount-code-checker>
            <div>
              <h2 class="text-[26px] font-black mb-3 mt-10">{{ $t('shared.payment') }}</h2>
              <p v-if="isPackFlight">{{ $t("step.2_payments") }}</p>
            </div>
            <div>
              <div class="payment-methods-container">
                <payment-methods-component></payment-methods-component>
                <transition name="slide-fade">
                  <redsys-component ref="redsysComponent" :gift="gift" :nights="nights" :extras="extras"></redsys-component>
                </transition>
              </div>
            </div>
            <v-btn
                rounded
                light
                block
                elevation="0"
                color="secondary"
                @click="retrievePaymentParameters"
                :loading="loading"
                class="avm-btn mx-auto xl:hidden mt-12"
              >
                {{ $t('shared.finalize_purchase') }}
              </v-btn>
        </template>

        <template v-slot:right>
          <div class="summary-container space-y-5">
            <!-- <app-box-timer class="hidden xl:flex"></app-box-timer> -->
            <box-summary :selectedCategory="selectedCategory" :packHotels="packHotels" :extraNoPromoPercentage="extraNoPromoPercentage" :totalPrice="totalPrice" :totalPriceLuxury="totalPriceLuxury">
              <v-btn
                rounded
                light
                block
                elevation="0"
                color="secondary"
                @click="retrievePaymentParameters"
                :loading="loading"
                class="avm-btn mx-auto"
              >
                {{ $t('shared.finalize_purchase') }}
              </v-btn>
            </box-summary>
          </div>
        </template>
      </nights-two-columns>
  </app-step>
</template>

<script>
import { mapGetters } from "vuex";
import { GET_PAYMENT_METHOD } from "../../../store/getter-types";
import { SET_PAYMENT_METHOD } from "../../../store/mutation-types";
import {
  GET_EXTRA_NO_PROMO_PRICE,
  GET_RESERVATION_ID,
  NIGHTS_GET_IS_PACK_FLIGHT,
NIGHTS_GET_LUXURY_EXTRA,
NIGHTS_GET_PACK_HOTELS,
NIGHTS_GET_SELECTED_CATEGORY,
NIGHTS_GET_TOTAL_PRICE_PACK_LUXURY,
NIGHTS_GET_TOTAL_PRICE_PACK_STANDARD
} from "../../../store/nights/getter-types";
import DiscountCodeChecker from "../personal-data/DiscountCodeChecker.vue";
import NightsTwoColumns from "../common/NightsTwoColumns.vue";
import BoxSummary from "../common/BoxSummary.vue";
export default {
  props: {
    gift: {
      type: Boolean,
      default: false,
    },
    extras: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      nights: true
    }
  },
  components: {
    DiscountCodeChecker,
    NightsTwoColumns,
    BoxSummary
  },
  computed: {
    ...mapGetters({
      reservationId: GET_RESERVATION_ID,
      isPackFlight:  NIGHTS_GET_IS_PACK_FLIGHT,
      packHotels: NIGHTS_GET_PACK_HOTELS,
      selectedCategory:NIGHTS_GET_SELECTED_CATEGORY,
      totalPrice: NIGHTS_GET_TOTAL_PRICE_PACK_STANDARD,
      totalPriceLuxury: NIGHTS_GET_TOTAL_PRICE_PACK_LUXURY,
      extraLuxury: NIGHTS_GET_LUXURY_EXTRA,
      extraNoPromoPercentage: GET_EXTRA_NO_PROMO_PRICE
    }),
    paymentMethod: {
      get() {
        return this.$store.getters[GET_PAYMENT_METHOD];
      },
      set(value) {
        this.$store.commit(SET_PAYMENT_METHOD, value);
      },
    },
  },

  methods: {
    initializePaymentMethod() {
      this.paymentMethod = 'redsysVisa';
    },

    selectPaymentMethod(method) {
      this.paymentMethod = method;
    },
    retrievePaymentParameters() {
      if (this.isPackFlight) {
        window.location.href = `/reservation/${this.reservationId}/payment`
        // window.location.href = `/mas-de-un-dia/${this.reservationId}/confirmacion`;
      } else {
        this.$refs.redsysComponent.retrievePaymentParameters();
      }
    },
  },
  created() {
    this.initializePaymentMethod()
  }
};
</script>

<style scoped lang="scss">
@import "../../../../sass/variables";

.payment-methods-container {
  display: flex;
  gap: 1rem;

  .rounded {
    border-radius: 15px !important;
  }
}

.booking-box {
  border-radius: 5px;
  position: relative;
  cursor: pointer;


  &.selected {
    border: 2px solid $turquoiseBlue;
    margin: -1px 0;

    .check {
      display: block;
    }
  }

  .check {
    display: none;
    position: absolute;
    bottom: -15px;
    left: 50%;
    transform: translateX(-50%);
  }
}

.payment-method-item {
  .img-container {
    height: 60px;
    border-radius: 15px !important;

    img {
      &.visa {
        height: 40px;
      }

      &.maestro {
        height: 43px;
      }

      &.mastercard {
        height: 50px;
      }
    }
  }
}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}

.slide-fade-leave-active {
  transition: all 0.4s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter,
.slide-fade-leave-to

/* .slide-fade-leave-active below version 2.1.8 */
  {
  transform: translateX(1000px);
  opacity: 0;
}
</style>
